import {authHeader, jsonAuthHeader} from './auth-header';
import {MAIN_API_URL, REVIEW_API_URL} from "../containers/canopia/CanopiaUtils";

class DownloadService {

    getTemplate(params) {
        return fetch(MAIN_API_URL + "template?fileName=" + params.fileName, {
            headers: authHeader(),
            cache: 'no-store'
        })
            .then(response => {
                    let contentType = response.headers.get("content-type");

                    if (contentType) {
                        if (contentType.indexOf("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") !== -1) {
                            return response.blob();
                        } else if (contentType.indexOf("application/json") !== -1) {
                            return response.json();
                        } else {
                            console.log("Unsupported content type found: " + contentType);
                        }
                    }
                }
            )
            .catch(error => error)
    }

    getExcelReport(params) {
        return fetch(MAIN_API_URL + "export?clientId=" + params.clientId + "&dateStr=" + params.date, {
            headers: authHeader(),
            cache: 'no-store'
        })
            .then(response => {
                    let contentType = response.headers.get("content-type");

                    if (contentType) {
                        if (contentType.indexOf("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") !== -1) {
                            return response.blob();
                        } else if (contentType.indexOf("application/json") !== -1) {
                            return response.json();
                        } else {
                            console.log("Unsupported content type found: " + contentType);
                        }
                    }
                }
            )
            .catch(error => error)
    }

    getPdfReport(params) {
        // For IE
        // if (!String.prototype.replaceAll) {
        //     String.prototype.replaceAll = function (str, newStr) {
        //         // If a regex pattern
        //         if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
        //             return this.replace(str, newStr);
        //         }
        //         // If a string
        //         return this.replace(new RegExp(str, 'g'), newStr);
        //     };
        // }

        // let cat = params.category.replaceAll('&', encodeURIComponent('&'));
        // cat = cat.replaceAll('+', encodeURIComponent('+'));
        return fetch(MAIN_API_URL + "download-pdf",
            {
                body: JSON.stringify(params),
                headers: jsonAuthHeader(), method: "POST", cache: 'no-store'
            })
            .then(response => {
                    let contentType = response.headers.get("content-type");

                    if (contentType) {
                        if (contentType.indexOf("application/pdf") !== -1) {
                            return response.blob();
                        } else if (contentType.indexOf("application/json") !== -1) {
                            return response.json();
                        } else {
                            console.log("Unsupported content type found: " + contentType);
                        }
                    }
                }
            )
            .catch(error => error)
    }

    getArchive(params) {
        return fetch(MAIN_API_URL + "archive?clientId=" + params.clientId + "&dateStr=" + params.date, {
            headers: authHeader(),
            cache: 'no-store'
        })
            .then(response => {
                    let contentType = response.headers.get("content-type");

                    if (contentType) {
                        if (contentType.indexOf("application/zip") !== -1) {
                            return response.blob();
                        } else if (contentType.indexOf("application/json") !== -1) {
                            return response.json();
                        } else {
                            console.log("Unsupported content type found: " + contentType);
                        }
                    }
                }
            )
            .catch(error => error)
    }

    getHistory(params) {
        return fetch(REVIEW_API_URL + "history?clientId=" + params.clientId, {headers: authHeader(), cache: 'no-store'});
    }

    getAnyFile(clientId, date, dir, fileName, apiUrl) {
        return fetch(apiUrl + "download?clientId=" + clientId + "&dateStr=" + date + "&dir=" + dir + "&fileName=" + fileName, {
            headers: authHeader(),
            cache: 'no-store'
        })
            .then(response => {
                    let contentType = response.headers.get("content-type");

                    if (contentType) {
                        if (contentType.indexOf("application/json") !== -1) {
                            return response.json();
                        }
                        if (contentType.includes("application") || contentType.includes("image") || contentType.includes("text")) {
                            return response.blob();
                        } else {
                            console.log("Unsupported content type found: " + contentType);
                        }
                    }
                }
            )
            .catch(error => error)
    }
}

const downloadService = new DownloadService();
export default downloadService;
